import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { cloneDeep } from 'lodash'
import filter from './modules/filter'
import { MessageBox } from 'element-ui'
import mp3 from '@/assets/music/lichuangjingbao.mp3'
import { setComId, setGrpid } from '@/tool/auth.js'

Vue.use(Vuex)
let timer = null
let audio = new Audio()
audio.loop = true

const getDefaultState = () => {
  return {
    /**
     * DepartName: ""
     * UserCode: ""
     * UserId: ""
     * UserName: ""
     */
    user: JSON.parse(localStorage.getItem('user')),
    //长者数组
    ElderlyCares: [],
    //当日长者执行项目
    Items: [],
    //护理历史 近3天
    NurseSignatureViews: [],
    //更新数据开关
    updateSwitch: 1,
    //是否需要更新护理数据
    isNeedNursing: true,

    //上次刷卡登录的卡id
    cardId: '',

    awaitElderlyCares: [],
    awaitItems: [],
    awaitNurseSignatureViews: [],
    filterscreenLoading: false,
    saveVal: 0,

    isFullScreen: false,
    isThree: false,
    isFlat: true,
    timerCode: null,
    timer: null,
    time: 10000,
    scanCode: '',
    tokenBaidu: '',
    isScanCode: false,
    floorShiftValue: 0
  }
}
const store = new Vuex.Store({
  namespace: true,
  state: getDefaultState(),
  getters: {
    user: (state) => {
      return state.user || JSON.parse(localStorage.getItem('user'))
    },
    isFlatThreeFullScreen: (state) => {
      return state.isFullScreen && state.isThree && state.isFlat
    },
    isFlatThree: (state) => {
      return state.isThree && state.isFlat
    }
  },
  mutations: {
    updateCardId(state, cardId) {
      state.cardId = cardId
    },
    updateFullScreen(state, isFullScreen) {
      state.isFullScreen = isFullScreen
    },
    updateThree(state, isThree) {
      state.isThree = isThree
    },
    updateFlat(state, isFlat) {
      state.isFlat = isFlat
    },
    //进入老者页执行一次，关闭左侧筛选完成执行一次（打开时先会清除计时器），在老者页面非筛选框触屏时执行一次，【老者页面关闭时清除计时器】
    resetTime(state) {
      if (state.isFlat && state.isThree) {
        if (state.timer) {
          clearTimeout(state.timer)
        }
        state.timer = setTimeout(() => {
          if (state.isFlat && state.isThree) {
            state.isFullScreen = true
          }
        }, state.time)
      }
    },
    //更新用户信息
    updatedUser(state, user) {
      localStorage.setItem('user', JSON.stringify(user))
      state.user = user
    },
    //设置护理请求开关
    setNursingSwitch(state, val) {
      state.isNeedNursing = val
    },
    //更新护理数据
    updateNursing(state, { ElderlyCares, Items, NurseSignatureViews }) {
      state.isNeedNursing = false
      state.ElderlyCares = ElderlyCares
      state.Items = Items
      state.NurseSignatureViews = NurseSignatureViews
    },
    updateSave(state) {
      state.saveVal++
    },
    // 1.是否开启扫码才能执行
    setIsScanCode(state, val) {
      state.isScanCode = val
    },

    // 2.设置是否通过扫码进去护理人员的id,用来前端控制是否可以操作长者
    setScanCode(state, val) {
      //清除定时器
      if (state.timerCode) {
        clearTimeout(state.timerCode)
        state.timerCode = null
      }
      //有值，设置扫码失效
      if (val) {
        let timerCode = setTimeout(
          () => {
            state.scanCode = ''
          },
          5 * 60 * 1000
        )
        state.timerCode = timerCode
      }
      state.scanCode = val
    },

    // 3.护士交班新增功能的字段配置
    setFloorShiftSystem(state, val) {
      state.floorShiftValue = val
    },

    // 开启告警定时器
    warningTip(state) {
      console.log('开启定时')
      if (timer) {
        clearInterval(timer)
        timer = null
      }
      // 临沂床垫  每隔一分钟，去查询一次报警记录
      if (localStorage.getItem('grpid') === '005558') {
        timer = setInterval(() => {
          store.commit('GetSleepNotice')
        }, 60000)
      }

      // 龙岗报警
      if (localStorage.getItem('grpid') === '010229') {
        timer = setInterval(() => {
          store.commit('getAlarm')
        }, 10000)
      }
      // if (localStorage.getItem('grpid') === '000081') {
      //   timer = setInterval(() => {
      //     store.commit('getAlarm')
      //   }, 12000)
      // }
      // 本地报警
      // if(localStorage.getItem('grpid') === '000081'){
      //   timer = setInterval(() => {
      //       store.commit('getAlarm')
      //   }, 5000);
      // }
    },

    // 获取床垫告警信息
    GetSleepNotice() {
      // this.loadings = true
      axios.post('/AlarmingDevice/GetSleepNotice').then((response) => {
        if (response.data.ok) {
          if (response.data.obj.length > 0) {
            var audio = new Audio()
            audio.src = mp3
            audio.play()

            let str = response.data.obj[0]
            str = str.replace('#', '楼')
            str = str.replace('-', '房间')
            str = str + '床离床'
            MessageBox.confirm(str, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            })
              .then(() => {})
              .catch(() => {})
          }
        } else {
          this.$message.error({
            message: response.data.msg,
            offset: 100
          })
        }
      })
    },

    // 获取护士站告警信息
    getAlarm(state) {
      axios
        .get(`/AlarmingDevice/GetCallAlarmInformation?hid=${localStorage.getItem('grpid')}&userId=${state.user.UserId}`)
        .then((res) => {
          const data = res.data.obj || 1
          if (res.data.code === 1 && data) {
            // 告警声音
            const text = data.alarm_text || 123
            if (text) {
              try {
                if (state.tokenBaidu) {
                  var token = state.tokenBaidu
                  var ttsText = encodeURI(text)
                  var url = 'https://tts.baidu.com/text2audio?cuid=baike&lan=zh&ctp=1' + '&tex=' + ttsText + '&tok=' + token
                  audio.src = url
                  audio.play()
                } else {
                  axios.get('http://datanotify.gshis.com/api/DataAnalysis/GetAlartAccessTokenMessage?text=123456').then((res) => {
                    var token = res.data.obj
                    state.tokenBaidu = token
                    var ttsText = encodeURI(text)
                    var url = 'https://tts.baidu.com/text2audio?cuid=baike&lan=zh&ctp=1' + '&tex=' + ttsText + '&tok=' + token
                    audio.src = url
                    audio.play()
                  })
                }
              } catch (error) {
                console.log('error: ', error)
              }
            }
            // 弹框
            const str = `
                  <div>时间：${data.call_time || ''}</div>
                  <div>科室：${data.part_name || ''}</div>
                  <div>区域：${data.callee_position || ''}</div>
                  <div>位置：${data.caller_position || ''}</div>
                  <div>信息：${data.alarm_text || ''}</div>
                  `
            MessageBox.confirm(str, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            })
              .then(() => {
                audio.pause()
              })
              .catch(() => {
                audio.pause()
              })
          }
        })
        .catch((err) => {
          // clearInterval(timer)
        })
    },

    // 退出登录，此处逻辑不完善，暂时只是让用户退出登录
    loginOut(state) {
      localStorage.removeItem('user')
      Object.assign(state, getDefaultState())
      if (timer) clearInterval(timer)
    }
  },
  actions: {
    login({ commit, dispatch }, userInfo) {
      const { token, comId } = userInfo
      console.log('userInfo: ', userInfo)
      return new Promise((resolve, reject) => {
        axios.defaults.headers['X-Auth-Grpid'] = comId
        axios.defaults.headers['X-Auth-ComId'] = comId
        axios
          .post('/HyApp/GetVerificationToken', { token: decodeURIComponent(token) })
          .then((res) => {
            setGrpid(res.data.obj.grpid) //集团id
            setComId(comId) //机构id
            axios.defaults.headers['X-Auth-Grpid'] = res.data.obj.grpid
            axios.defaults.headers['X-Auth-ComId'] = comId
            if (res.data.obj.name) {
              res.data.obj = {
                ...res.data.obj,
                UserName: res.data.obj.name,
                UserId: res.data.obj.id,
                Grpid: res.data.obj.grpid
              }
            } else {
              res.data.obj = {
                ...res.data.obj,
                name: res.data.obj.UserName,
                id: res.data.obj.UserId,
                grpid: res.data.obj.Grpid
              }
            }

            commit('updatedUser', res.data.obj)
            // dispatch('getSystemData')
            resolve()
          })
          .catch((err) => {
            commit('loginOut')
            reject(err)
          })
      })
    },
    //获取护理数据
    getNursingInformation({ state, getters, commit }) {
      state.filterscreenLoading = true
      return axios
        .post('/Pad/NursingInformation/NursingInformation', {
          ElderlyList: true,
          NursingHistoryPlan: true,
          UserId: getters.user.UserId
        })
        .then((res) => {
          state.filterscreenLoading = false
          let obj = res.data.obj
          obj.Items.map((item) => {
            // item.timestamp=new Date(item.DTime).getTime()
            item.newDTime = item.DTime.substr(0, item.DTime.length - 3).replace('T', ' ')
            item.newInputDate = item.InputDate ? item.InputDate.substr(0, item.InputDate.length - 3) : item.InputDate
            //缓存后续可能更改的值方便还原
            item.oldStatus = item.Status
            item.oldValue = item.Value
            item.oldRemark = item.Remark
            item.oldModels = cloneDeep(item.Models)
          })
          console.log('obj', obj)
          commit('updateNursing', obj)
        })
        .catch((err) => {
          state.filterscreenLoading = false
        })
    },
    //同步护理数据
    updateNursingInformation({ state, getters, dispatch }, { ElderlyCares, Items, NurseSignatureViews }) {
      state.filterscreenLoading = true

      axios
        .post(`/Pad/NursingEditInformation?cUser=${getters.user.UserName}&cUserId=${getters.user.UserId}`, {
          // ElderlyCares:ElderlyCares||state.awaitElderlyCares,
          Items: Items || state.awaitItems
          // NurseSignatureViews:NurseSignatureViews||state.awaitNurseSignatureViews
        })
        .then((res) => {
          dispatch('getNursingInformation')
        })
        .catch((err) => {
          state.filterscreenLoading = false
        })
    },
    // 获取当前机构的系统参数配置
    getSystemData({ commit }) {
      // 开启定时器
      commit('warningTip')
      // 扫码配置
      axios.get(`/Pad/GetHYPara?code=IsNecessaryToScan`).then((res) => {
        commit('setIsScanCode', res.data.obj && res.data.obj.Value === '1')
      })
      // 护士楼层新增配置
      axios.get(`/Pad/GetHYPara?code=IsFloorShiftSystem`).then((res) => {
        commit('setFloorShiftSystem', Number(res.data.obj && res.data.obj.Value))
      })
    }
  },
  modules: {
    filter
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js